import React from 'react'
import HeroImg from '../Assets/HeroImg.png'

export default function Hero () {
    return(
        <div className='flex items-center justify-center mt-20'>
            <div className='w-11/12'>
                <div className='text-center'>
                    <h1 className='text-[3.7rem] font-[900] leading-[65px]'>ARTIFICIAL INTELLIGENCE PEOPLE <br /> ECOSYSTEM</h1>
                    <p className='text-[1.1rem] text-[#6B7280] mt-5'>A Platform to Distribute & Orchestrate Between AI Teams</p>
                    <button className='w-[15.7rem] h-[2.6rem] bg-[#942A27] rounded-[8px] text-white font-[500] mt-8'>START AI TEAMS JOURNEY</button>
                </div>
                <div className='flex items-center justify-center mt-14'>
                    <img className='w-11/12' src={HeroImg} />   
                </div>
            </div>
        </div>
    );
}